module.exports = __webpack_public_path__ + "static/media/Elf2.f93ad40b.png";